module.exports = __webpack_public_path__ + "img/task-handle-right.6f0125cc.svg";